import React from 'react';
import { FunctionComponent } from 'react';

import styled, { css } from '@benzinga/themetron';

export const fontFamilyStylesObject: React.CSSProperties = {
  fontFamily: '"proxima-nova", "helvetica", "arial", sans-serif',
};

export const fontFamilyStyles = css`
  font-family: 'proxima-nova', 'helvetica', 'arial', sans-serif;
`;

export const RowStyles = css`
  display: flex;
  flex-direction: row;
  min-width: 0%;
`;

export const StretchRowStyles = css`
  ${RowStyles};
  justify-content: space-between;
`;

export const ColumnStyles = css`
  display: flex;
  flex-direction: column;
`;

export const InlineStyles = css`
  display: inline;
`;

export const Row = styled.div`
  ${RowStyles};
`;

export const StretchRow = styled.div`
  ${StretchRowStyles};
`;

export const Column = styled.div`
  ${ColumnStyles};
`;

export const Inline = styled.div`
  ${InlineStyles};
`;

export const Div = styled.div``;

export const Span = styled.span``;

export const Anchor = styled.a``;

// example default styles for a component
export const codeEnhancer = css`
  background: ${props => props.theme.colors.backgroundActive};
  border: 1px solid ${props => props.theme.colors.border};
  color: ${props => props.theme.colors.foregroundActive};
  flex-direction: column;
  font-family: monospace;
  overflow: auto;
  padding: 1em;
  white-space: pre;
`;

export const Code = styled(Column)`
  ${codeEnhancer};
`;

export interface FooProps {
  className: string;
  name: string;
}

// In order for styletron to style custom components, they must accept className as an argument.
// eslint-disable-next-line no-unused-vars
export const Foo: FunctionComponent<FooProps> = ({ className, name }) => <Row className={className}>{name}</Row>;
